export default "__VITE_ASSET__4c21d036__"